import { render } from "./CartTable.vue?vue&type=template&id=27275be9&ts=true"
import script from "./CartTable.vue?vue&type=script&lang=ts"
export * from "./CartTable.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/momo-store-main/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__